export * from './theme-icons.interface';
export type { IconProps } from './icon';
export { Icon } from './icon';
export { useIcon } from './use-icon.hook';
